<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;height:auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Page-Module Master</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form
              v-if="$sessionsStorage.get('designation') == 'Admin' &&  $sessionsStorage.get('nameUser') == 'Bhavneesh' ">
              <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
              <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                @click="getAllPageModuleMasterList('Excel')" size="sm" variant="outline-info">{{ ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>

            </b-nav-form>

          </b-navbar-nav>

          <!-- <b-button
            v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
            size="sm"
            class="ml-1"
            @click="getReports('All_Module_Report')"
            variant="outline-info"
          >Export</b-button>-->
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="justify-content-left">
                <b-col md="12">
                  <h5>{{PageModuleMaster.pagemodule_name}} Page-Module Details</h5>
                </b-col>
                <b-col md="2">
                  <label>Module Name <span class="error">*</span></label>
                  <model-list-select :list="$store.getters['common/getAllModuleList']"
                    v-model="PageModuleMaster.fk_module_id" option-value="module_id" option-text="module_name"
                    placeholder="Select Module Name"
                    @input="SubModuleDataGet(PageModuleMaster.fk_module_id)"></model-list-select>
                  <span class="error" v-if="!PageModuleMaster.fk_module_id">{{ errorList.fk_module_id }}</span>
                </b-col>
                <b-col md="2" v-if="PageModuleMaster.fk_module_id != ''">
                  <label>SubModule Name <span class="error">*</span></label>
                  <model-list-select :list="$store.getters['common/getAllSubModuleList']" id="submodule_id"
                    v-model="PageModuleMaster.fk_submodule_id" option-value="submodule_id" option-text="submodule_name"
                    placeholder="Select Sub-Module Name"></model-list-select>
                  <span class="error" v-if="!PageModuleMaster.fk_submodule_id">{{ errorList.fk_submodule_id }}</span>
                </b-col>
                <b-col md="3">
                  <label>Page-Module Name <span class="error">*</span></label>
                  <b-form-input :formatter="capitalizeAll" id="pagemodule_name" name="pagemodule_name"
                    v-model="PageModuleMaster.pagemodule_name" placeholder="Page Module Name"
                    @input="submoduleUrl(PageModuleMaster.pagemodule_name)"></b-form-input>
                  <span class="error" v-if="!PageModuleMaster.pagemodule_name">{{ errorList.pagemodule_name }} </span>
                </b-col>
                <b-col md="3">
                  <label>Page-Module URL <span class="error">*</span></label>
                  <b-form-input id="pagemodule_url" name="pagemodule_url" v-model="PageModuleMaster.pagemodule_url"
                    placeholder="Page-Module URL"></b-form-input>

                  <!-- <span class="error" v-if="!PageModuleMaster.pagemodule_url">{{ errorList.pagemodule_url  }}</span> -->
                </b-col>

                <b-col md="2">
                  <label>Status</label> <br>
                  <md-switch :id="'approval'+PageModuleMaster.is_pagemodule_active" name="approval" class="md-primary"
                    :value="PageModuleMaster.is_pagemodule_active==1?true:false" @change="activatepagemoduleMaster()">
                    <h6>
                      <b-badge
                        :variant="PageModuleMaster.is_pagemodule_active==1?'success':'danger'">{{PageModuleMaster.is_pagemodule_active==1?"Active":"In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addPageModuleMaster" class="mt-2"
                      id="addButtonLoader">
                      {{ PageModuleMaster.pagemodule_id ? "Update" : "Save" }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Page Module Master" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <h5><small v-if="isLoading == false">{{ totalRows }} Entries</small></h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="All_Page_Module_List_data" :fields="fields"
                  :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" responsive
                  primary-key="pagemodule_id" class="position-relative">
                  <template slot="pagemodule_id" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="module_name" slot-scope="row5">
                    <span><b>Module Name: </b>{{row5.item.module_name }}</span>
                    <br>
                    <span><b>Sub-Module Name: </b>{{row5.item.submodule_name }}</span>
                  </template>
                  <template slot="pagemodule_name" slot-scope="row1">
                    <span
                      @click="$sessionsStorage.get('designation') == 'Admin' &&  $sessionsStorage.get('nameUser') == 'Bhavneesh'? viewEdit(row1.item):''"
                      class="showMoreData">{{row1.item.pagemodule_name}}</span>
                  </template>
                  <template slot="pagemodule_url" slot-scope="row11">
                    <span>{{(row11.item.pagemodule_url!='')?row11.item.pagemodule_url:'--'}}</span>
                  </template>
                  <template slot="is_pagemodule_active" slot-scope="row22">
                    <div v-if="adminToggle =='Admin'" :id="'row'+row22.item.pagemodule_id">
                      <md-switch :id="'approval'+row22.item.pagemodule_id" name="approval" class="md-primary"
                        :value="row22.item.is_pagemodule_active==1?true:false"
                        @change="activateModuleUser(row22.item, 'Active')">
                        <h6>
                          <br>
                          <b-badge
                            style="margin-left:-45px">{{row22.item.is_pagemodule_active==1?'Active':'In-Active'}}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row'+row22.item.pagemodule_id">
                      <h6>
                        <b-badge>{{row22.item.is_pagemodule_active==1?'Active':'In-Active'}}</b-badge>
                      </h6>
                    </div>
                  </template>
                  <template slot="is_pagemodule_delete" slot-scope="row22">
                    <div v-if="adminToggle =='Admin'" :id="'row'+row22.item.pagemodule_id">
                      <md-switch :id="'approval'+row22.item.pagemodule_id" name="approval" class="md-primary"
                        :value="row22.item.is_pagemodule_delete==1?true:false"
                        @change="activateModuleUser(row22.item, 'Delete')">
                        <h6>
                          <br>
                          <b-badge style="margin-left:-45px">{{row22.item.is_pagemodule_delete==1?'Delete':'Not Deleted'}}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row'+row22.item.pagemodule_id">
                      <h6>
                        <b-badge>{{row22.item.is_pagemodule_delete==1?'Deleted':'Not Delete'}}</b-badge>
                      </h6>
                    </div>
                  </template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editPageModuleMaster(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/pagemoduleMaster");
      if (globalPermissionStatus("Page-Module Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Page-Module Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      this.getAllPageModuleMasterList('Normal');
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
    this.$store.dispatch(
      "common/setAllModuleList",
      JSON.stringify({
        itemCode: "ModuleList",
      })
    );
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "pagemodule_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "module_name",
          label: "Module Details",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "pagemodule_name",
          label: "Page-Module Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "pagemodule_url",
          label: "Page-Module URL",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "is_pagemodule_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "is_pagemodule_delete",
          label: "Is Delete",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "action",
          label: "action",
          sortable: true,
          sortDirection: "desc"
        },
      ],
      currentPage: 1,
      perPage: 10,
      adminToggle: this.$sessionsStorage.get("designation"),
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      PageModuleMaster: {
        pagemodule_id: "",
        fk_module_id: "",
        fk_submodule_id: "",
        module_name: "",
        submodule_name: "",
        pagemodule_name: "",
        pagemodule_url: "",
        is_pagemodule_active: true,
        TypeofAdd: "Page-Module Master Add"
      },
      PageModuleMasterError: [
        "Please Select Module Name",
        "Please Enter Sub-Module Name",
        "Please Enter Page-Module Name",
        "Please Enter Page-Module URL",
      ],
      errorList: {
        fk_module_id: "",
        fk_submodule_id: "",
        pagemodule_name: "",
        pagemodule_url: "",
      },
      All_Page_Module_List_data: [],
      validate: true
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  mounted() {
    
  },
  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
    
  },
  methods: {
    activatepagemoduleMaster() {
      if (this.PageModuleMaster.is_pagemodule_active == 1 || this.PageModuleMaster.is_pagemodule_active == true) {
        this.PageModuleMaster.is_pagemodule_active = false;
      } else if (
        this.PageModuleMaster.is_pagemodule_active == 0 ||
        this.PageModuleMaster.is_pagemodule_active == false
      ) {
        this.PageModuleMaster.is_pagemodule_active = true;
      }
    },
    SubModuleDataGet(module_id) {
      this.$store.dispatch(
        "common/setAllSubModuleList",
        JSON.stringify({
          itemCode: "SubModule_List",
          Filter: { 
            statusFilter: "1",
            module_id: module_id,
          },
          type: "Normal",
        })
      );
    },
    activateModuleUser(item, type) {
      let FieldVal = '';
      let TableField = '';
      if(type == "Active"){
        FieldVal = item.is_pagemodule_active == 1 ? 0 : 1;
        TableField = "is_pagemodule_active";
      } else if(type == "Delete"){
        FieldVal = item.is_pagemodule_delete == 1 ? 0 : 1;
        TableField = "is_pagemodule_delete";
      }
      let payload = {
          tableName: "pagemodule_master",
          tableId: "pagemodule_id",
          tableIsActive: TableField,
          value1: FieldVal,
          tableVal: item.pagemodule_id,
          isMailSend:'No',
          manual:'No',
      };
      //console.log("Payload => ", payload); return false;
      ClientUserService.getAllActive(JSON.stringify(payload))
      .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getAllPageModuleMasterList("Normal");
          }
      })
      .catch((error) => {
          console.log("Catch on getAllActive Error: ", error);
      });
    },


    validatePageModuleMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
          if (
          this.PageModuleMaster[x] == "" ||
          this.PageModuleMaster[x] == undefined ||
          this.PageModuleMaster[x] == null
          ) {
              console.log("this.PageModuleMaster[x]=>",this.PageModuleMaster[x],x);
              console.log("this.PageModuleMaster[x]=>",this.PageModuleMaster);
          this.errorList[x] = this.PageModuleMasterError[index];
          validate_new = false;
          }
      });
      if (validate_new != true) {
          this.validate = false;
          return;
      } else {
          this.validate = true;
      }
    },
    addPageModuleMaster() {
      this.validatePageModuleMaster();
      this.PageModuleMaster.TypeofAdd = "Page-Module Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
          itemCode: "add_Page_Module_Details",
          PageModuleMaster: this.PageModuleMaster
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
          CommonService.getAllCommonMaster(payload)
          .then(response => {
              const { data, status, statusText } = response;
              if (data.pagemodule_id != "" && data.pagemodule_id != undefined) {
                if (data.find == 1 || data.find == 2) {
                    this.alert.content = data.MSG;
                } else {
                    this.alert.content = data.MSG;
                }
                this.addEditCardFunc();
                this.getAllPageModuleMasterList('Normal');
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
          })
          .catch(error => {
              console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    clearErrVal() {
      this.PageModuleMaster = {
        pagemodule_id: "",
        fk_module_id: "",
        fk_submodule_id: "",
        module_name: "",
        submodule_name: "",
        pagemodule_name: "",
        pagemodule_url: "",
        is_pagemodule_active: true,
        TypeofAdd: "Page-Module Master Add"
      };
    },
    getAllPageModuleMasterList(type) {
      this.All_Page_Module_List_data = [];
      this.totalRows = 0;
      this.isLoading = true;
      if(type == "Excel"){
        this.ExcelBtnName = "Downloading Please Wait...";
      }
      let payload = {
          itemCode: "All_Page_Module_List",
          Filter: this.filter,
          type: type,
      };
      // JSON.stringify();
      // await
      CommonService.getAllCommonMaster(payload)
      .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excel") {
              this.ExcelBtnName = "Export As Excel";
              if (data.All_Page_Module_List_data.length > 0) {
                this.All_Page_Module_List_data = data.All_Page_Module_List_data;
                this.totalRows = data.All_Page_Module_List_data.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.All_Page_Module_List_data.length > 0) {
                this.All_Page_Module_List_data = data.All_Page_Module_List_data;
                this.totalRows = data.All_Page_Module_List_data.length;
                console.log(" All_Page_Module_List_data response=>", data);
              }
            }
          } else {
            this.All_Page_Module_List_data = [];
          }
          this.isLoading = false;
      })
      .catch(error => {
          console.log("Catch on All_Page_Module_List_data Error: ", error);
      });
    },
    
    editPageModuleMaster(item) {
      console.log(item);
      this.clearErrVal();
      this.addEditCard = true;
      item.TypeofAdd = "Page-Module Master Add";
      this.PageModuleMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function() {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllPageModuleMasterList('Normal');
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllPageModuleMasterList('Normal');
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },

    submoduleUrl(item) {

      const pagemoduleName = item.toLowerCase().replaceAll(' ',"_");
      console.log('modulename => ', pagemoduleName);
      this.PageModuleMaster.pagemodule_url = pagemoduleName; 
    },
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// pagemoduleMaster.vue?a41cf880